<h1 mat-dialog-title>Continuidad laboral</h1>
<div mat-dialog-content>

</div>
